"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenAmountProfileProvider = ScreenAmountProfileProvider;
const React = __importStar(require("react"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const uom_1 = require("@genesys/uom");
const ScreenAmounts = __importStar(require("@genesys/shared/lib/screen-amounts"));
const GraphQLQuery = __importStar(require("../graphql-query"));
const MutationsQueueUser = __importStar(require("../mutations-queue-user"));
const Contexts = __importStar(require("../contexts"));
const Elements = __importStar(require("../elements"));
const mutations_1 = require("./mutations");
const productDataQuery = (0, graphql_tag_1.default) `
  query ScreenAmountProfileProviderProductData {
    product {
      genesysNumberPrefixes {
        id
        genesysNo
        pricingNo
      }

      fieldDefaults {
        id
        fieldGroup
        fieldName
        measureSystem
        unit
        decimalCount
      }

      quantityDefaults {
        id
        measureSystem
        quantity
        unit
        decimalCount
      }
    }
  }
`;
const userQuery = (0, graphql_tag_1.default) `
  query ScreenAmountProfileProviderUserData {
    user {
      userProfile {
        id

        userSettings {
          id
          amountFieldProfiles {
            id
            name
            measureSystem
            isEditable
            amountFieldFormats {
              id
              fieldGroup
              fieldName
              measureSystem
              unit
              decimalCount
            }
          }
          selectedAmountFieldProfile {
            id
            measureSystem
            amountFieldFormats {
              id
              fieldGroup
              fieldName
              measureSystem
              unit
              decimalCount
            }
          }
        }
      }
    }
  }
`;
function ScreenAmountProfileProvider({ children }) {
    return (React.createElement(GraphQLQuery.QueryProduct, { query: productDataQuery, variables: {} }, productDataResult => (React.createElement(MutationsQueueUser.MutationsQueue, null, ({ mutationQueue, queueAndFlush }) => (React.createElement(GraphQLQuery.QueryUser, { query: userQuery, variables: {}, mutationsQueue: mutationQueue }, userResult => {
        if (productDataResult.type === "ErrorResultProps" ||
            userResult.type === "ErrorResultProps") {
            return (React.createElement("p", null, "ScreenAmountProfileProvider: Error loading data queries"));
        }
        if (productDataResult.type === "PartialResultProps" ||
            userResult.type === "PartialResultProps") {
            return React.createElement(Elements.Loader, null);
        }
        return (React.createElement(ScreenAmountProfileProviderInternal, { productData: productDataResult.data, userData: userResult.data, children: children, queueAndFlush: queueAndFlush }));
    }))))));
}
class ScreenAmountProfileProviderInternal extends React.Component {
    getPropertyFormats(fieldGroup, properties) {
        return ScreenAmounts.buildPropertyFormatsMap(this.state.childProps.quantityDefaults, this.state.childProps.fieldDefaults, this.state.childProps.userAmountFields, this.state.childProps.measureSystem, fieldGroup, properties);
    }
    getAmountFormat(fieldGroup, fieldName, amountOrQuantity) {
        return ScreenAmounts.getAmountFormat(this.state.childProps.quantityDefaults, this.state.childProps.fieldDefaults, this.state.childProps.userAmountFields, this.state.childProps.measureSystem, fieldGroup, fieldName, amountOrQuantity);
    }
    saveAmountFieldFormat(fieldGroup, fieldName, unit, decimalCount) {
        const unitString = uom_1.Serialize.unitToString(unit);
        this.props.queueAndFlush([
            {
                type: "AddToQueueMutationDescription",
                mutation: (0, mutations_1.saveAmountFieldFormatQueuedMutation)(this.state.childProps.selectedAmountProfileId, this.state.childProps.measureSystem, fieldGroup, fieldName, decimalCount, unitString)
            }
        ]);
    }
    deleteAmountFieldFormat(fieldGroup, fieldName) {
        this.props.queueAndFlush([
            {
                type: "AddToQueueMutationDescription",
                mutation: (0, mutations_1.deleteAmountFieldFormatQueuedMutation)(this.state.childProps.selectedAmountProfileId, fieldGroup, fieldName)
            }
        ]);
    }
    updateAmountFieldProfile(id, name, measureSystem) {
        this.props.queueAndFlush([
            {
                type: "AddToQueueMutationDescription",
                mutation: (0, mutations_1.updateAmountFieldProfileQueuedMutation)(id, name, measureSystem)
            }
        ]);
    }
    setActiveAmountFieldProfile(id) {
        this.props.queueAndFlush([
            {
                type: "AddToQueueMutationDescription",
                mutation: (0, mutations_1.setActiveAmountFieldProfileQueuedMutation)(id, this.props.userData.user.userProfile.id)
            }
        ]);
    }
    constructor(props) {
        super(props);
        const { fieldDefaults, quantityDefaults } = props.productData.product;
        this.state = {
            childProps: {
                getPropertyFormats: this.getPropertyFormats.bind(this),
                getAmountFormat: this.getAmountFormat.bind(this),
                amountFieldProfiles: [],
                quantityDefaults: ScreenAmounts.createQuantityDefaultsMap(quantityDefaults),
                fieldDefaults: ScreenAmounts.createFieldsDefaultsMap(fieldDefaults),
                userAmountFields: {},
                measureSystem: 1,
                selectedAmountProfileId: ScreenAmounts.SIProfileId,
                saveAmountFieldFormat: this.saveAmountFieldFormat.bind(this),
                deleteAmountFieldFormat: this.deleteAmountFieldFormat.bind(this),
                updateAmountFieldProfile: this.updateAmountFieldProfile.bind(this),
                setActiveAmountFieldProfile: this.setActiveAmountFieldProfile.bind(this)
            }
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { amountFieldProfiles, selectedAmountFieldProfile } = nextProps.userData.user.userProfile.userSettings;
        const selectedAmountProfileId = (selectedAmountFieldProfile && selectedAmountFieldProfile.id) ||
            ScreenAmounts.SIProfileId;
        const measureSystem = (selectedAmountFieldProfile &&
            selectedAmountFieldProfile.measureSystem) ||
            1;
        return {
            childProps: Object.assign(Object.assign({}, prevState.childProps), { userAmountFields: ScreenAmounts.createUserAmountFieldsMap(selectedAmountFieldProfile.amountFieldFormats), selectedAmountProfileId: selectedAmountProfileId, measureSystem, amountFieldProfiles: amountFieldProfiles })
        };
    }
    render() {
        return (React.createElement(Contexts.ScreenAmountProfileContext.Provider, { value: this.state.childProps }, React.Children.only(this.props.children)));
    }
}
//# sourceMappingURL=screen-amount-profile-provider.js.map